'use strict';

const MOBILE_NET_MODE = require('../../../../../constant').MOBILE_NET_MODE;

function parse(reader) {
    reader.readUInt8('data.params', value => MOBILE_NET_MODE[value]);
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_3/common/rule/mobile-network-parser.js